import { render, staticRenderFns } from "./ProfileWidgetCard.vue?vue&type=template&id=66cd277a&scoped=true&"
import script from "./ProfileWidgetCard.vue?vue&type=script&lang=ts&"
export * from "./ProfileWidgetCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileWidgetCard.vue?vue&type=style&index=0&id=66cd277a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd277a",
  null
  
)

export default component.exports